import React from "react";
import { useAppContext } from "../../contexts/AppContext";
import Spinner from "./Spinner";
import _SharedLayout from "../../pages/SharedLayout";

interface AuthenticatedAppWrapperProps {
  children: React.ReactNode;
}

const AuthenticatedAppWrapper: React.FC<AuthenticatedAppWrapperProps> = ({
  children,
}) => {
  const { isDataLoading, isDataReady } = useAppContext();

  // Show loading spinner while data is being fetched
  if (isDataLoading) {
    return (
      <div className="flex flex-column align-items-center justify-content-center min-h-screen">
        <Spinner size="xl" />
      </div>
    );
  }

  // Show error state if data failed to load
  if (!isDataReady) {
    return (
      <div className="flex flex-column align-items-center justify-content-center min-h-screen">
        <div className="flex flex-column align-items-center gap-3">
          <i className="pi pi-exclamation-triangle text-4xl text-red-500" />
          <p className="text-lg font-medium text-700">
            Failed to load application data
          </p>
          <p className="text-sm text-600">
            Please refresh the page or contact support if the problem persists.
          </p>
        </div>
      </div>
    );
  }

  // Data is ready, render the actual content
  return <>{children}</>;
};

export default AuthenticatedAppWrapper;
